import { Component } from 'react';
import styles from './SupportModal.module.css';

export class SupportModal extends Component {
    renderIcon() {
        const Icon = this.props.iconComponent;
        return <Icon className={styles.icon} />;
    }

    renderTitle() {
        const { title } = this.props;

        return <div className={styles.title}>{title}</div>;
    }

    renderCaption() {
        const { caption } = this.props;

        return <div className={styles.caption}>{caption}</div>;
    }

    renderButton() {
        const { button } = this.props;

        return <div className={styles.button}>{button}</div>;
    }

    renderAvailabilityMessage() {
        const { availabilityMessage } = this.props;

        return <div className={styles.message}>{availabilityMessage}</div>;
    }

    render() {
        const icon = this.renderIcon();
        const title = this.renderTitle();
        const caption = this.renderCaption();
        const button = this.renderButton();
        const availabilityMessage = this.renderAvailabilityMessage();
        return (
            <div className={styles.SupportModal} data-testid="support-modal">
                {icon}
                {title}
                {caption}
                {button}
                {availabilityMessage}
            </div>
        );
    }
}
